// zrm-utils-js
import { pathsManifest as PathsManifest } from '@zg-rentals/zrm-utils-js';

const getAllPaths = (brand?: string) => {
    const pathsManifest = new PathsManifest('/rental-manager', brand);

    return pathsManifest.getAllPaths();
};

export default {
    getAllPaths
};
